import { SwiperSlide, Swiper } from 'swiper/react';
import Skeleton from 'react-loading-skeleton';
import config from '../../configuration/config';

export default function OverviewHeader({
    lang,
    history,
    isLoadingImages,
    filterCarImages,
    vehicle,
    activeModel,
    cachSNImages,
    gallery,
    popGalleryRef,
    FetchCarSNImages,
    trans,
}) {
    return (
        <>
            {/* Back button – desktop and mobile unified with better glassmorphism
            <div className="flex nice-absolute mb-10" style={{ top: '16px', left: lang === 'en' ? '16px' : 'auto', right: lang === 'ar' ? '16px' : 'auto', zIndex: 100 }}>
                <div
                    className="hj-glass-panel border-radius back-btn nice-pointer nice-shadow-1"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '10px 18px',
                        borderRadius: '14px',
                        cursor: 'pointer',
                        transition: 'all .3s var(--co-ease)',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: 'var(--co-t1)',
                        boxShadow: '0 4px 20px rgba(0,0,0,.15)',
                        border: '1px solid rgba(255,255,255,.4)',
                    }}
                    onClick={() => history.push({ pathname: `/VehicleOnline`, search: '' })}
                >
                    <svg
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2.5"
                        style={{ transform: lang === 'ar' ? 'rotate(180deg)' : 'none' }}
                    >
                        <line x1="19" y1="12" x2="5" y2="12" />
                        <polyline points="12 19 5 12 12 5" />
                    </svg>
                    <span className="hide-xs">{trans('info:back')}</span>
                </div>
            </div> */}

            {isLoadingImages ? (
                <div className="vh-img rv vis" style={{ width: '100%', height: '420px', overflow: 'hidden' }}>
                    <Skeleton
                        baseColor="rgba(0,0,0,0.05)"
                        highlightColor="rgba(0,0,0,0.01)"
                        count={1}
                        width={'100%'}
                        height={'100%'}
                        borderRadius={'24px'}
                    />
                </div>
            ) : (
                <div className="vh-img rv vis" style={{ width: '100%', height: '420px' }}>
                    {/* New badge */}
                    {vehicle?.newCar && (
                        <div className="vh-badge">
                            {vehicle?.year} {trans('info:new')}
                        </div>
                    )}

                    {/* Image slider with subtle background */}
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={1}
                        resizeObserver={true}
                        grabCursor={true}
                        autoplay={false}
                        pagination={{ clickable: true }}
                        loop={false}
                        observer={true}
                        style={{ height: '100%', width: '100%' }}
                    >
                        {filterCarImages && filterCarImages.length > 0
                            ? filterCarImages.map((image, index) => (
                                <SwiperSlide key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img
                                        alt={vehicle?.name || ''}
                                        src={config.FilePathURL + image.Image_URL}
                                    />
                                </SwiperSlide>
                            ))
                            : null}
                    </Swiper>

                    {/* Actions – Floating preview button */}
                    {vehicle && activeModel?.sn && cachSNImages && cachSNImages[activeModel?.sn] && cachSNImages[activeModel?.sn].length > 0 && (
                        <div style={{ position: 'absolute', bottom: '24px', left: lang === 'en' ? '24px' : 'auto', right: lang === 'ar' ? '24px' : 'auto', zIndex: 10 }}>
                            <div
                                onClick={(event) => {
                                    event.stopPropagation();
                                    FetchCarSNImages(activeModel?.sn);
                                    try {
                                        if (popGalleryRef && gallery && gallery?.length > 0) {
                                            popGalleryRef.current.toggleFullScreen();
                                        }
                                    } catch (error) { }
                                }}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    padding: '10px 20px',
                                    borderRadius: '16px',
                                    cursor: 'pointer',
                                    boxShadow: '0 6px 20px rgba(0,0,0,.08)',
                                    border: '1px solid rgba(0,0,0,.1)',
                                    background: 'var(--surface)',
                                }}
                            >
                                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'var(--g)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                                        <circle cx="12" cy="13" r="4"></circle>
                                    </svg>
                                </div>
                                <span style={{ fontSize: '15px', fontWeight: 700, color: 'var(--t1)' }}>{trans('info:Preview')}</span>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}
